import {PageBody, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {Header} from '@/components/commons/header/Header'
import {Divider} from '@/components/ui/divider/Divider'
import {Helmet} from 'react-helmet'
import {useTranslation} from '@/translations/i18n'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {useAuthStore, usePermissions} from '@/features/auth/store/store'
import {formatLocaleDate} from '@/dayjs'
import {CalendarIcon} from '@/components/ui/icon/Icon'
import {HomeNotificationsCard} from '@/features/home/components/home-notifications-card/HomeNotificationsCard'
import {HomeEventsCard} from '@/features/home/components/home-events-card/HomeEventsCard'
import {HomeProjectsCard} from '@/features/home/components/home-projects-card/HomeProjectsCard'
import {HomeReportCard} from '@/features/home/components/home-report-card/HomeReportCard'
import {StyledHomePageWrapper, StyledHomeWrapper} from './style'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Navigate} from 'react-router-dom'
import {routes} from '@/utilities/constants/routes'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'

export const Home = () => {
    const {t} = useTranslation()
    const user = useAuthStore(state => state.user)
    const permissions = usePermissions()
    const today = new Date()
    const todayFormatted = formatLocaleDate(today, 'dddd D MMMM')

    // Redirect users with administrative permissions to dashboard
    // Following the app pattern: if user has settings access, they're likely an admin
    if (permissions?.settings?.read) {
        return <Navigate to={routes.DASHBOARD.path} replace />
    }

    return (
        <StyledHomePageWrapper>
            <Helmet title={t('homepage:meta_title')} />
            <PageBody>
                <Header />
                <Divider direction="horizontal" />
                <PageContent>
                    <StyledHomeWrapper>
                        <Flexbox direction="column" gap={6}>
                            <Flexbox direction="column" gap={1.5}>
                                <Text size="displaySm" weight={500} palette="neutral" shade="950">
                                    {user?.firstName
                                        ? t('homepage:greeting', {name: user.firstName})
                                        : t('homepage:greeting_default')}
                                </Text>
                                <Flexbox gap={1.5} align="center">
                                    <Text size="textLg" palette="neutral" shade="600">
                                        {t('homepage:check_activities')}
                                    </Text>
                                    <Text size="textLg" weight={500} palette="neutral" shade="950">
                                        {todayFormatted}
                                    </Text>
                                </Flexbox>
                            </Flexbox>

                            <Divider direction="horizontal" />

                            <Grid columns={2} columnGap={4} rowGap={8} fullWidth>
                                {permissions?.agenda.read && <HomeEventsCard />}
                                <HomeNotificationsCard />
                                {!permissions?.projects.read && <div />}
                                <HomeProjectsCard />
                                <HomeReportCard />
                            </Grid>
                            {permissions?.agenda.read && permissions?.agenda.write && (
                                <Flexbox gap={4}>
                                    <ButtonLink to={routes.AGENDA_ROUTE.handle.path} variant="secondary" size="md">
                                        <CalendarIcon />
                                        {t('homepage:add_event')}
                                    </ButtonLink>
                                </Flexbox>
                            )}
                        </Flexbox>
                    </StyledHomeWrapper>
                </PageContent>
            </PageBody>
        </StyledHomePageWrapper>
    )
}
